export function SettingsCookiesAnonymousRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.SettingsCookiesAnonymous', {
		url: '/preferences/cookies/anonymous',
		controllerAs: 'vm',
		controller: SettingsCookiesAnonymousCtrl,
		templateUrl: '/ng/hub/Settings/Cookies/Anonymous/SettingsCookiesAnonymousCtrl.html?' + window.BUILD,
		resolve: {},
	});
}

export class SettingsCookiesAnonymousCtrl {
	constructor() {
		'ngInject';
	}
}
